import ArticleCard from '@/components/base/ArticleCard';
import { getHotArticles } from '@/mocks/articles';

export default function HotArticles() {
  const hotArticles = getHotArticles();

  return (
    <section className="w-full px-6 md:px-8 py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
            <i className="ri-fire-line text-white text-sm"></i>
          </div>
          <h2 className="text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            热门曝光
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {hotArticles.map((article) => (
            <ArticleCard
              key={article.id}
              slug={article.slug}
              title={article.title}
              excerpt={article.excerpt}
              coverImage={article.coverImage}
              category={article.category}
              author={article.author}
              publishedAt={article.publishedAt}
              readCount={article.readCount}
              tags={article.tags}
            />
          ))}
        </div>
      </div>
    </section>
  );
}